import styled, { keyframes } from "styled-components";

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const Container = styled.div`
  max-width: 1440px;
  width: 100%;
  margin: 0 auto;
`;

export const Button = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border-radius: 100px;
  background: #27272a;
  border: none;

  padding: 8px 24px;
  gap: 10px;
  font-size: 15px;
  font-family: DM Sans;

  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  margin-left: auto;

  outline: none;
  position: absolute;
  top: 0;
  right: 0;
  @media (max-width: 558px) {
    margin-left: unset;
    width: fit-content;
  }
`;
export const LoadingIndicator = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px;
  font-size: 16px;
  color: #666;
  width: 100%;
  gap: 5px;

  width: 100rem;
  min-height: 483px;

  span {
    font-family: DM Sans;
  }
`;
export const BackButton = styled.button`
  color: #fff;
  font-family: DM Sans;
  font-size: 15px;
  font-weight: 400;
  opacity: 0.7;
  display: inline-flex;
  align-items: center;
  margin-bottom: 4px;
  background: none;
  border: none;
  outline: none;
  width: fit-content;
  cursor: pointer;
  gap: 8px;
  margin-left: -6px;
  letter-spacing: -0.075px;
  margin-top: 16px;
`;

export const Title = styled.h1`
  font-size: 26px;
  font-weight: 500;
  color: ${({ theme }) => (theme === "light" ? "#1a1a1a" : "#fff")};
  margin-bottom: 32px;
`;

export const CurrentPlanSection = styled.div`
  position: relative;
  display: flex;
  gap: 17px;
  flex-wrap: wrap;
  flex-direction: column;
  @media (max-width: 558px) {
    flex-direction: column-reverse;
    gap: 10px;
  }
  margin-bottom: 24px;
`;

export const PlanInfo = styled.div`
  display: flex;
  align-items: center;

  gap: 3px;
`;

export const PlanLabel = styled.span`
  color: ${({ theme }) =>
    theme === "light" ? "rgba(0, 0, 0, 0.6)" : "rgba(255, 255, 255, 0.7)"};
  font-size: 16px;
  font-weight: 700;
  align-items: end;
  display: flex;
  gap: 5px;
`;

export const Highlight = styled.div`
  position: absolute;
  top: 4px;
  bottom: 4px;
  left: ${({ $left }) => $left}px;
  width: ${({ $width }) => $width}px;
  background: #f3f3f3;
  border-radius: calc(25px - 4px);
  transition: all 0.3s ease;
  opacity: ${(props) => (props.$open ? 1 : 0)};
  z-index: 0;
`;

export const PlanValue = styled.span`
  color: ${({ theme }) => (theme === "light" ? "#1a1a1a" : "#fff")};
  font-size: 18px;
  font-weight: 700;
`;

export const CreditsInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const CreditsLabel = styled.span`
  color: ${({ theme }) =>
    theme === "light" ? "rgba(0, 0, 0, 0.6)" : "rgba(255, 255, 255, 0.7)"};
  font-size: 15px;
  font-weight: 500;
`;

export const CreditsValue = styled.span`
  color: rgb(255, 255, 255);
  font-size: 17px;
  font-weight: 700;
`;

export const BalanceSection = styled.div``;

export const SectionTitle = styled.h2`
  font-size: 15px;
  font-weight: 500;
  color: ${({ theme }) => (theme === "light" ? "#1a1a1a" : "#fff")};
  margin-bottom: 16px;
`;

// New styled component for section header with chevron
export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  margin-bottom: 16px;
  transition: all 0.3s ease;

  &:hover {
    opacity: 0.8;
  }

  ${SectionTitle} {
    margin-bottom: 0;
  }
`;

// New styled component for table container with animation
export const TableContainer = styled.div`
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  max-height: ${({ $isExpanded }) => ($isExpanded ? "609px" : "0px")};
  opacity: ${({ $isExpanded }) => ($isExpanded ? 1 : 0)};
  transform: ${({ $isExpanded }) =>
    $isExpanded ? "translateY(0)" : "translateY(-20px)"};
  margin-bottom: ${({ $isExpanded }) => ($isExpanded ? "0" : "-16px")};

  /* Additional smooth animation for the inner content */
  ${({ $isExpanded }) =>
    !$isExpanded &&
    `
    pointer-events: none;
  `}

  overflow-x: auto;

  &::-webkit-scrollbar {
    width: 0px;
    height: 3px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #2877d9;
    border-radius: 100px;
  }
`;

export const Table = styled.table`
  width: 100%;
  min-width: 700px;
  border-radius: 8px;
  overflow: hidden;
  border-spacing: 0 12px;
`;

export const TableRow = styled.tr`
  &:last-child {
    border-bottom: none;
  }
`;

export const TableHeader = styled.th`
  text-align: left;
  color: #fff;
  padding-bottom: 12px;
  font-weight: 400;
  font-size: 14px;
  opacity: 0.4;
`;

export const TableCell = styled.td`
  padding: ${({ $isFirst }) => ($isFirst ? "6px 8px" : "6px 0px")};
  font-weight: 400;
  color: #fff;
  font-size: 14px;
  border-bottom: 1px solid #353535;
`;
export const TimeAgoCell = styled(TableCell)`
  position: relative;
  cursor: help;
`;
export const TableLoading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
`;
export const Tooltip = styled.div`
  position: absolute;
  bottom: 100%;
  left: 50px;
  transform: translateX(-50%) translateY(10px);
  background: ${({ theme }) =>
    theme === "light" ? "#1a1a1a" : "rgba(255, 255, 255, 0.95)"};
  color: ${({ theme }) => (theme === "light" ? "#fff" : "#1a1a1a")};
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
  white-space: nowrap;
  opacity: ${({ $show }) => ($show ? "1" : "0")};
  visibility: ${({ $show }) => ($show ? "visible" : "hidden")};
  transition: all 0.2s ease;
  pointer-events: none;
  z-index: 1000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

  &::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 6px solid transparent;
    border-top-color: ${({ theme }) =>
      theme === "light" ? "#1a1a1a" : "rgba(255, 255, 255, 0.95)"};
  }
`;
export const TableFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 700px;
`;

export const FooterText = styled.span`
  color: ${({ theme }) =>
    theme === "light" ? "rgba(0, 0, 0, 0.5)" : "rgba(255, 255, 255, 0.6)"};
  font-size: 14px;
`;

export const Pagination = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

export const PaginationButton = styled.button`
  background: none;
  border: none;
  color: ${(props) => {
    if (props.disabled) {
      return props.theme === "light"
        ? "rgba(0, 0, 0, 0.3)"
        : "rgba(255, 255, 255, 0.3)";
    }
    return props.theme === "light"
      ? "rgba(0, 0, 0, 0.6)"
      : "rgba(255, 255, 255, 0.7)";
  }};
  font-size: 14px;
  cursor: ${(props) => (props.disabled ? "default" : "pointer")};
  transition: color 0.3s ease;

  &:hover:not(:disabled) {
    color: ${({ theme }) => (theme === "light" ? "#000" : "#fff")};
  }
`;

export const PaginationCurrent = styled.span`
  color: ${({ theme }) => (theme === "light" ? "#1a1a1a" : "#fff")};
  font-size: 14px;
`;

export const PricingSection = styled.div`
  margin-bottom: 48px;
  width: 100%;

  border-radius: 20px;
  border: 1px solid #18181b;
  padding: 16px;
  gap: 24px;
  background: #0c0c0e;
`;

export const BillingToggle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 32px;
  width: fit-content;
  margin-inline: auto;
`;

export const BillingText = styled.p`
  color: #fff;
  font-family: DM Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px; /* 114.286% */
`;

export const SavingsText = styled.p`
  color: ${({ theme }) => (theme === "light" ? "#1a1a1a" : "#fff")};
  font-size: 18px;
  font-weight: 600;
  margin: 0;
`;

export const SavingsRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
`;

export const SavingIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  animation: ${rotate} 4s linear infinite;
`;

export const ToggleContainer = styled.div`
  display: flex;
  background: ${({ $rightValueSelected }) =>
    $rightValueSelected ? "#e2e8f0" : "#ffffff1e"};

  border-radius: 25px;
  padding: 4px;
  position: relative;
  width: 3.5rem;
  height: 1.8rem;
  transition: background-color 0.5s ease-in-out;
`;
export const SaleBadge = styled.div`
  display: inline-flex;
  transform: rotate(15deg);
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 100px;
  background: linear-gradient(0deg, #033d66 -47.22%, #00a3a3 100%);
  position: absolute;
  right: -35px;
  text-transform: uppercase;
  height: 25px;
  top: -15px;
  color: #fafafa;
  font-family: DM Sans;
  font-size: 13px;
  font-weight: 600;
  line-height: 16px; /* 123.077% */

  align-items: center;
  gap: 10px;
  border-radius: 20px;
  background: #18181b;
`;
export const ToggleButton = styled.button`
  border: none;
  z-index: 2;
  cursor: pointer;
  padding: 2px;
  color: ${(props) => (props.$active ? "#000" : "red")};
  font-family: DM Sans;
  font-size: 16px;
  font-weight: 600;
  line-height: 16px;
  margin-top: -3px;
  height: 1.6rem;
  width: 1.6rem;
  background-color: ${({ $rightValueSelected }) =>
    $rightValueSelected
      ? "#0f172b"
      : "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.2) 100%), red;"};
  border-radius: 10px;
  border: none;
  position: absolute;
  transform: ${({ $rightValueSelected }) =>
    $rightValueSelected && "translateX(85%)"};
  transition: all 0.5s ease-in-out;
`;

export const PlansGrid = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  max-width: 1440px;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;

  @media (max-width: 1100px) {
    display: flex;
    flex-direction: column;
  }
`;

export const PlanCard = styled.div`
  background: ${(props) => props.$gradient};
  border-radius: 24px;
  padding: 24px;
  gap: 24px;
  position: relative;
  align-items: flex-start;
  color: white;
  display: flex;
  flex-direction: column;

  max-width: 400px;
  width: 100%;

  border: ${(props) =>
    props.$active ? "0.5px solidrgba(255, 255, 255, 0.57)" : "none"};
  box-shadow: ${(props) =>
    props.$active ? "0 12px 24px 0rgb(31, 45, 113)" : "none"};
`;

export const PopularBadge = styled.div`
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  color: rgb(51, 51, 51);
  font-family: DM Sans;
  font-size: 14px;
  font-weight: 800;
  line-height: 16px; /* 114.286% */
  text-transform: uppercase;
  height: 25px;
  display: inline-flex;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 100px;
  border: 0.5px solid #fff;
  background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.2) 100%
    ),
    #fff;
`;

export const PlanName = styled.h3`
  color: #fff;
  font-family: DM Sans;
  font-size: 24px;
  font-weight: 600;
`;

export const PlanDescription = styled.p`
  color: #fff;
  font-family: DM Sans;
  font-size: 12px;
  font-weight: 500;
  opacity: 0.3;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
`;

export const PriceSection = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 4px;
  margin-bottom: 8px;
`;

export const OriginalPrice = styled.span`
  color: #fff;
  font-family: DM Sans;
  font-size: 22px;
  font-weight: 00;
  text-decoration-line: line-through;
`;

export const CurrentPrice = styled.span`
  color: #fff;
  font-family: DM Sans;
  font-size: 32px;
  font-weight: 700;
  letter-spacing: -0.5px;
`;

export const PricePeriod = styled.span`
  color: #fff;
  font-family: DM Sans;
  font-size: 18px;
  font-weight: 400;
  opacity: 0.4;
`;

export const YearlyTotal = styled.p`
  color: #fff;

  font-family: DM Sans;
  font-size: 16px;

  font-weight: 500;
`;

export const BillingNote = styled.p`
  font-size: 12px;
  margin: 0 0 24px 0;
  opacity: 0.7;
`;

export const GetStartedButton = styled.button`
  border-radius: 100px;
  border: 0.5px solid #fff;
  background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.2) 100%
    ),
    #fff;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.12);

  display: flex;
  height: 44px;
  padding: 12px 32px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  align-self: stretch;
  position: relative;
  overflow: hidden;

  color: #09090b;
  font-family: DM Sans;
  font-size: 16px;
  font-weight: 600;
  line-height: 150%; /* 24px */
  letter-spacing: 0.08px;
  cursor: pointer;

  transition: all 0.3s ease-in-out;

  /* Subtle shimmer effect */
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 50%;
    height: 100%;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.49) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    animation: buttonShimmer 4s infinite;
    pointer-events: none;
  }

  @keyframes buttonShimmer {
    0% {
      left: -100%;
    }
    100% {
      left: 150%;
    }
  }

  &:hover:not(:disabled) {
    transform: ${(props) => (props.$isActive ? "none" : "translateY(-1px)")};
    box-shadow: 0 4px 15px rgba(255, 255, 255, 0.1);
  }
`;

export const FeaturesList = styled.ul`
  list-style: none;
  padding: 0;
  text-align: left;
`;

export const Feature = styled.li`
  color: #fff;
  font-family: DM Sans;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  gap: 9px;
  margin-bottom: 12px;

  svg {
    flex-shrink: 0;
  }
  &:last-child {
    margin-bottom: 0;
  }
`;

export const FAQSection = styled.div`
  transition: all 0.3s ease-in-out;
  margin-top: 18px;
  margin-bottom: 48px;
`;

export const FAQList = styled.div`
  min-height: 410px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

// Add these styled components to SubscriptionPage.styles.js

export const FooterActions = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

export const ShowGrantsButton = styled.button`
  background: none;
  border: 1px solid
    ${({ theme }) =>
      theme === "light" ? "rgba(0, 0, 0, 0.2)" : "rgba(255, 255, 255, 0.2)"};
  color: ${({ theme }) =>
    theme === "light" ? "rgba(0, 0, 0, 0.7)" : "rgba(255, 255, 255, 0.8)"};
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;

  &:hover {
    background: ${({ theme }) =>
      theme === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.1)"};
    border-color: ${({ theme }) =>
      theme === "light" ? "rgba(0, 0, 0, 0.3)" : "rgba(255, 255, 255, 0.3)"};
  }
`;

export const FAQItem = styled.div`
  background: ${({ theme }) =>
    theme === "light" ? "rgba(0, 0, 0, 0.03)" : "rgba(255, 255, 255, 0.05)"};
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
  border: ${({ theme }) =>
    theme === "light" ? "1px solid rgba(0, 0, 0, 0.1)" : "none"};
`;

export const FAQQuestion = styled.button`
  width: 100%;
  background: none;
  border: none;
  color: ${({ theme }) => (theme === "light" ? "#1a1a1a" : "#fff")};
  padding: 20px;
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  font-family: DM Sans;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background 0.3s ease;

  &:hover {
    background: ${({ theme }) =>
      theme === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"};
  }

  svg {
    flex-shrink: 0;
    opacity: 0.7;
  }
`;

export const FAQAnswer = styled.div`
  padding: ${({ $isExiting }) =>
    $isExiting ? "0 20px" : "10px 20px 20px 20px"};
  max-height: ${({ $isExiting }) => ($isExiting ? "0" : "200px")};
  opacity: ${({ $isExiting }) => ($isExiting ? "0" : "1")};
  overflow: hidden;
  color: ${({ theme }) =>
    theme === "light" ? "rgba(0, 0, 0, 0.7)" : "rgba(255, 255, 255, 0.8)"};
  font-size: 14px;
  line-height: 1.6;
  /* max-width: 1000px; */
  background: ${({ theme }) =>
    theme === "light" ? "rgba(0, 0, 0, 0.02)" : "rgba(255, 255, 255, 0.02)"};
  transition: all 0.3s ease-out;
  transform: ${({ $isExiting }) =>
    $isExiting ? "translateY(-10px)" : "translateY(0)"};
  /* Enter animation */
  ${({ $isExiting }) =>
    !$isExiting &&
    `
    animation: slideDown 0.3s ease-out;
  `}

  @keyframes slideDown {
    from {
      max-height: 0;
      padding-top: 0;
      padding-bottom: 0;
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      max-height: 200px;
      padding-top: 10px;
      padding-bottom: 20px;
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
